import {
  googleAnalyticsEvent,
  loadGoogleAnalytics,
  googleAnalyticsPageView,
} from './googleAnalytics';
import {
  loadSegmentScript,
  segmentAnalyticsIdentify,
  segmentAnalyticsPageView,
  segmentAnalyticsTrack,
} from './segment';

export * from './monitoring';

export const pageview = (url: string) => {
  googleAnalyticsPageView(url);
  segmentAnalyticsPageView(url);
};

export type AnalyticsEventProps = {
  event_category?: string;
  event_label?: string;
  value?: number;
};

export type AnalyticsIdentifyProps = {
  email?: string;
  phone?: string;
  country?: string;
};

export function analyticsEvent(
  eventName: string,
  props?: AnalyticsEventProps,
  meta?: Record<string, any>
) {
  googleAnalyticsEvent(eventName, props);
  segmentAnalyticsTrack(eventName, {
    ...props,
    ...meta,
  });
}
export function analyticIdentify(userId: string, props?: AnalyticsIdentifyProps) {
  segmentAnalyticsIdentify(userId, props);
}

(window as any).analyticsEvent = analyticsEvent;
(window as any).analyticIdentify = analyticIdentify;

export type SetupAnalyticsParams = {
  gaTrackingId?: string;
  heapAppId?: string;
  segmentWriteKey?: string;
};

export async function loadAnalytics({
  gaTrackingId,
  heapAppId,
  segmentWriteKey,
}: SetupAnalyticsParams) {
  if (gaTrackingId) {
    await loadGoogleAnalytics(gaTrackingId);
  }
  if (segmentWriteKey) loadSegmentScript(segmentWriteKey);
  if (heapAppId) {
    // TODO: Re-enable or remove heap
    // await loadHeap(heapAppId);
  }
}

export { segmentAnalyticsTrack };
